import { create } from "zustand";

import { platform } from "@platform/index";
import { ItemType, Platform } from "@enums/common.enum";

interface IPlatformStore {
  itemId: string | null;
  itemSubject: string | null;
  itemType: ItemType | null;
  isComposeMode: boolean;
  calendarId: string | null;
  error: string | null;
  prevItemType: ItemType | null;
  // Seeded once from platform.current at module init.
  // Platform is a build-time constant, so this value never changes.
  platformName: Platform;

  isOutlook: () => boolean;
  isChrome: () => boolean;

  setPlatformData: (data: {
    itemId: string | null;
    itemSubject: string | null;
    itemType: ItemType | null;
    isComposeMode: boolean;
    calendarId?: string | null;
  }) => void;
  setError: (error: string | null) => void;
  setPrevItemType: (type: ItemType | null) => void;
}

const usePlatformStore = create<IPlatformStore>((set, get) => ({
  platformName: platform.current,
  itemId: null,
  itemSubject: null,
  itemType: null,
  isComposeMode: false,
  calendarId: null,
  error: null,
  prevItemType: null,

  isOutlook: () => get().platformName === Platform.OUTLOOK,
  isChrome: () => get().platformName === Platform.CHROME,

  setPlatformData: ({ itemId, itemSubject, itemType, isComposeMode, calendarId }) =>
    set((state) => ({
      itemId,
      itemSubject,
      itemType,
      isComposeMode,
      calendarId: calendarId ?? state.calendarId,
    })),
  setError: (error) => set({ error }),
  setPrevItemType: (prevItemType) => set({ prevItemType }),
}));

export default usePlatformStore;
